import React from 'react';
import s from './styles.module.css'
import Wrapper from "../../components/wrapper";
import HeaderTitle from "../../components/header_title";

const About = () => {
  return (
    <div className={s.main}>
      <Wrapper>
        <HeaderTitle/>
        <h1>Om os</h1> <p> Vi er en informationsplatform, der samler nyttige oplysninger om lån, finansielle produkter og privatøkonomi. Vores mål er at gøre det lettere at sammenligne forskellige muligheder og finde relevante tilbud. </p> <p> Hvis du ønsker at se aktuelle lånemuligheder, kan du gå
        til forsiden og sammenligne tilbud fra forskellige långivere. </p> <p> Denne hjemmeside udsteder ikke lån eller kreditter. </p> <p> Vi er ikke en bank, en kreditinstitution, en långiver eller en finansiel formidler. </p> <p> På hjemmesiden har vi samlet lånetilbud fra forskellige udbydere og
        gjort dem nemme at sammenligne ved hjælp af praktiske filtre og overskuelig information. </p> <p> Oplysningerne på denne hjemmeside udgør ikke finansiel rådgivning, en personlig anbefaling eller en opfordring til at optage et lån. Du bør altid selv vurdere, om et finansielt produkt passer
        til dine behov. </p> <p> Det er gratis at bruge vores hjemmeside. Vi opkræver ingen betaling fra brugerne for adgang til information eller sammenligning af lånetilbud. </p> <p> Vi samarbejder kun med långivere og finansielle virksomheder, der har de nødvendige tilladelser og licenser til at
        udbyde deres produkter i overensstemmelse med gældende lovgivning. </p>
      </Wrapper>
    </div>
  );
};

export default About;
